// extracted by mini-css-extract-plugin
export default {"actions":"ActionsBlock_actions__C2UMi"};